import React from 'react'
import { useSelector } from 'react-redux'
import { selectTaskStatus, selectErrorMessage } from 'store/optimizationSlice'
import './results.scss'
import CalcStatus from 'components/CalcStatus'
import useCheckTaskStatus from './hooks/useCheckTaskStatus'

const Results: React.FC = () => {
  const taskStatus = useSelector(selectTaskStatus)
  const errorMessage = useSelector(selectErrorMessage)

  useCheckTaskStatus()
  return (
    <div className={'edit-element-panel optimization-results__edit-element-panel'}>
      <div className={'hydraulic-calc__status-wrapper'}>
        <span className={'hydraulic-calc__title optimization-results__title header2'}>
          Автоматическое построение трубопровода.
        </span>
        <CalcStatus status={taskStatus} classNames={'optimization-results__status'} />
      </div>
      {taskStatus === 'Рассчитан' && (
        <div className={'optimization-info__error-message'}>
          {'Построение трубопровода прошло успешно. Оптимизированная геометрия трубопровода применена автоматически'}
        </div>
      )}
      {taskStatus === 'Ошибка' && errorMessage && (
        <div className={'optimization-info__error-message'}>{errorMessage}</div>
      )}
    </div>
  )
}

export default Results
